const accordion = document.getElementsByClassName('js-acc-heading');
for (i=0; i<accordion.length; i++) {
  accordion[i].addEventListener('click', function () {
    this.classList.toggle('active')
  })
}

let catNames = document.getElementsByClassName('js-faq-nav-item');
for(let catName of catNames) {
  catName.addEventListener('click', function () {
    for (let cat of catNames) {
      if(this.getAttribute("data-target") == cat.getAttribute("data-target")) {
        this.classList.add('active');
      }
      else {
        cat.classList.remove('active');
      }
    }

    let allContent = document.querySelectorAll('.js-faq-wrapper');
    for (let content of allContent) {
      if(content.id === this.getAttribute("data-target")) {
        content.style.display = "block";
      }
      else {
        content.style.display = "none";

      }
    }
  });
}
